import React from "react";
import { map } from "lodash";
import Dropdown from "@radarly/components/panels/card-edition/sidebar/dropdown";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { UsersCard } from "@radarly/models/cards";
import { editSortOnUserCard } from "@radarly/models/cards/editor";
import { getUserSort } from "@radarly/models/cards/form";
import { SortInfluencer } from "@radarly/models/search";

export interface SharedPanelsCardEditionSidebarUserSortProps {
  card: UsersCard;
  setCard: (card: UsersCard) => void;
}

export default function SharedPanelsCardEditionSidebarUserSort({
  card,
  setCard,
}: SharedPanelsCardEditionSidebarUserSortProps) {
  const locale = useCurrentUserLocale();
  const cardSort = getUserSort(card);
  return (
    <Dropdown
      label="Sort"
      onChange={({ value }) =>
        setCard(editSortOnUserCard(card, value as SortInfluencer))
      }
      value={{
        value: cardSort,
        label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SORT_BY_" + cardSort),
      }}
      options={map(card.fragments[0].request.aggs.users.metrics, (unit) => ({
        value: unit,
        label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SORT_BY_" + unit),
      }))}
    />
  );
}
